import React from 'react'
import {Outlet, Navigate} from 'react-router-dom'

const AuthRoute = ({children, auth}: any) => {

  return auth.id ? children : <Navigate to={'/auth'} replace/>
}

export default AuthRoute
